module.exports = "<section class=\"content\">\r\n  <div class=\"box\">\r\n    <div class=\"box-body\">\r\n      <div class=\"text-center\" style=\"padding:100px 0;\">\r\n        <h1 style=\"color:#a94442;\"><i class=\"fa fa-warning\"></i></h1>\r\n        <p>\r\n          The page or function that you tried to access is forbidden. The authorities have been contacted!\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/auth/un-authorized/un-authorized.component.html
// module id = ../../../../../src/app/auth/un-authorized/un-authorized.component.html
// module chunks = main